import { Flex } from "@acko-tech/building-blocks.ui.common";
import styled from "styled-components";

export const Wrapper = styled(Flex)`
    flex-direction: column;
    color: #040222;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
`;